export default __webpack_public_path__ + "static/media/vipps.2799998d.svg";